/*
    * Описание параметров:
        -- Selected_Well_IDs - IDs скважин
        -- Selected_Stratum_IDs - IDs пласта
        -- Selected_Element_IDs - IDs элемента
        -- Selected_Triplet_IDs - Сочетание ID скважины, пласта и элемента
*/

const map = {
    wellIDs: 'Selected_Well_IDs',
    stratumIDs: 'Selected_Stratum_IDs',
    elementIDs: 'Selected_Element_IDs',
    tripletIDs: 'Selected_Triplet_IDs',
};

const defaultParams = {
    wellIDs: 0,
    stratumIDs: 0,
    elementIDs: 0,
    tripletIDs: 0,
};

/*
    Объединяет базовые параметры с переданными. Так как все выше перечисленные значения должны участвовать в запросе.
    TODO: необходим контракт, чтобы избежать ошибки передачи параметров в функцию.
*/
export const settingsTreeParams = (params = {}) => {
    return Object.entries(defaultParams).reduce((acc, param) => {
        const [name, value] = param;

        if (name in params) {
            return { ...acc, [map[name]]: params[name] };
        }

        return { ...acc, [map[name]]: value };
    }, {});
};
